/* @flow */

export default function detectUserMention(input: String) {
  const spacedInput = input + ' ';
  const userMatch = spacedInput.match('@([a-zA-Z0-9_]+)[:;, ]');
  if (userMatch) {
    return userMatch[1];
  }
  return false;
}



// WEBPACK FOOTER //
// ../src/client/utils/detectUserMention.js